import React from 'react';

const HeadingH4 = (props) => {

    const { size, weight, color, textUpper } = props;

    let className= '';
    className += 'u-fontSize' + size;
    className += ' u-fontWeight' + weight;
    className += ' u-textColor' + color;
    if(textUpper) {
        className += ' u-textUppercase';
    }

    return (
        <h4 className={className}>{props.children}</h4>
    );
}

export default HeadingH4;


// WEBPACK FOOTER //
// ./src/components/UI/Headings/HeadingH4/HeadingH4.js